import { VehicleInsuranceInformation } from "@amsanalytics/react-shared-library";

export interface IAppCustomerVehicleInsurance extends VehicleInsuranceInformation {
  id?: string;
  // CPI fields (matching Customer Center CPI dialog)
  isCpi?: boolean;
  cpiFactor?: number;
  cpiStartDate?: Date | string | null;
  cpiNextAccrueDate?: Date | string | null;
  cpiSemi1DayOfMonth?: number | null;
  cpiSemi2DayOfMonth?: number | null;
}

export interface ICreateUpdateCustomerVehicleInsurance extends IAppCustomerVehicleInsurance {
  appCustomerId: string;
}

export const defaultCreateUpdateCustomerVehicleInsurance: ICreateUpdateCustomerVehicleInsurance = {
  appCustomerId: '',
  stockNumber: '',
  agent: '',
  agentPhone: '',
  fax: '',
  policyNumber: '',
  insuranceCompany: '',
  insuranceCompanyPhone: '',
  effectiveDate: null,
  expirationDate: null,
  collisionDeductible: 0,
  comprehensiveDeductible: 0,
  cancellationDate: null,
  lastUpdate: null,
  memo: '',
  memo2: '',
  insuranceVerificationRequestId: '',
  isCpi: false,
  cpiFactor: 0,
  cpiStartDate: null,
  cpiNextAccrueDate: null,
  cpiSemi1DayOfMonth: 0,
  cpiSemi2DayOfMonth: 0,
};